module.exports = __webpack_public_path__ + "static/img/gi.dce455a7.svg";